<!-- Footer -->
<footer class="bg-light text-center text-lg-start">
    <!-- Copyright -->
    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
        © 2023 Copyright:
        <a class="text-dark" href="https://autoverkooppartner.nl">Auto Verkoop Partner</a>
    </div>
    <!-- Copyright -->
</footer>